import { useEffect, useMemo, useState } from 'react';
import useCurrentWalletAdapter from './useCurrentWalletAdapter';

type ManualAlertResult = {
	showAlert: boolean;
	handleSeenAlert: () => void;
};

export const useShowPhantomAutoconnectAlert = (): ManualAlertResult => {
	const LOCAL_STORAGE_KEY = 'seenPhantomAutoconnectAlert';

	const currentWallet = useCurrentWalletAdapter();

	const currentWalletIsPhantom =
		currentWallet?.name?.toLowerCase() === 'phantom';

	const [showPhantomAutoconnectAlert, setShowPhantomAutoconnectAlert] =
		useState(false);

	useEffect(() => {
		if (currentWalletIsPhantom && !localStorage?.getItem(LOCAL_STORAGE_KEY)) {
			setShowPhantomAutoconnectAlert(true);
		} else {
			setShowPhantomAutoconnectAlert(false);
		}
	}, [currentWalletIsPhantom]);

	const handleSeen = () => {
		localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
		setShowPhantomAutoconnectAlert(false);
	};

	const result = useMemo(() => {
		return {
			showAlert: showPhantomAutoconnectAlert,
			handleSeenAlert: handleSeen,
		};
	}, [showPhantomAutoconnectAlert]);

	return result;
};
